import { render } from "./ConsultaSolicitudes.vue?vue&type=template&id=086de4ba"
import script from "./ConsultaSolicitudes.vue?vue&type=script&lang=js"
export * from "./ConsultaSolicitudes.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__